import _ from 'lodash'
import DocumentModel from '@/Modules/Document/DocumentModel.js'

export default class MessageModel {
  id = null
  direction = null
  type = null
  from = null
  to = null
  cc = null
  bcc = null
  subject = null
  text = null
  sendDate = null

  documents = []

  constructor(data = {}) {
    _.forEach(data, (value, field) => {
      this[_.camelCase(field)] = value
    })

    this.documents = data.documents && _.map(data.documents, document => new DocumentModel(document))
  }
}
